import { createSvgIcon } from '@mui/material'

export const UpdatesIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.3226 6.00631 8.71265 6.66082 7.50667 7.82667L6 9.33333M6 9.33333V6M6 9.33333H9.33333M6 12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.6774 17.9937 15.2874 17.3392 16.4933 16.1733L18 14.6667M18 14.6667H14.6667M18 14.6667V18'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'UpdatesIcon',
)
